import pluralize from 'helpers/pluralize'

const getPollTimeLabel = (timeDiffMs: number) => {
  const totalSeconds = Math.ceil(timeDiffMs / 1000)
  const totalMinutesCeil = Math.ceil(totalSeconds / 60)
  const totalHoursCeil = Math.ceil(totalMinutesCeil / 60)
  const totalDaysCeil = Math.ceil(totalHoursCeil / 24)

  switch (true) {
    case totalSeconds < 60:
      return pluralize('second', totalSeconds, true)
    case totalMinutesCeil < 60:
      return pluralize('minute', totalMinutesCeil, true)
    case totalHoursCeil < 24:
      return pluralize('hour', totalHoursCeil, true)
    default:
      return pluralize('day', totalDaysCeil, true)
  }
}

export default getPollTimeLabel
